module.exports = __webpack_public_path__ + "img/fp.020daf29.jpg";